<template>
  <div style="">
    <div style="display:flex; width: 100vw; height: 100vh">
      <Sidebar v-if="user.loggedIn" style="height :100%"></Sidebar>
      <main style="flex: 1; justify-content : center" :style="mainStyle">
        <router-view></router-view>
      </main>
    </div>
  </div>
</template>

<script>
import Sidebar from "./components/Sidebar";
import { mapGetters } from "vuex";
export default {
  components: {
    Sidebar
  },
  computed: {
    ...mapGetters({
      user: "user",
      sidebarHidden: "sidebarHidden",
      windowWidth: "windowWidth"
    }),
    mainHidden() {
      return !this.sidebarHidden && this.windowWidth < 800;
    },
    mainStyle() {
      return [this.mainHidden ? "display: none" : "display: flex", this.$route.name === 'login' ? 'padding-left: 0' : this.$store.getters.sidebarHidden ? "padding-left: 70px" : "padding-left: 318px"].join("; ");
    }
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH");
    }
  }
};
</script>

<style>
@import "./static/app.css";
</style>
